var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3290",
    "data-name": "Rectangle 3290",
    width: 12,
    height: 12,
    transform: "translate(1215 406)",
    fill: "#2e71fc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copyIconBlue",
    transform: "translate(-1215 -406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(1214.143 405.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M10.928,12.857h-6A1.929,1.929,0,0,1,3,10.928v-6A1.929,1.929,0,0,1,4.929,3h6a1.929,1.929,0,0,1,1.929,1.929v6a1.929,1.929,0,0,1-1.929,1.929Z",
    fill: "#2e71fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M4.286,2.143H10.6A1.932,1.932,0,0,0,8.786.857h-6A1.929,1.929,0,0,0,.857,2.786v6A1.932,1.932,0,0,0,2.143,10.6V4.286A2.143,2.143,0,0,1,4.286,2.143Z",
    fill: "#2e71fc",
    opacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconBlue);
export default __webpack_public_path__ + "static/media/copyIconBlue.f5bc73b55e8897d0bb5d8003fb75e8f0.svg";
export { ForwardRef as ReactComponent };